import React from "react";
import "./MetiersTicker.css";

const METIERS = [
  "Électriciens",
  "Plombiers",
  "Chauffagistes",
  "Couvreurs",
  "Menuisiers",
  "Maçons",
  "Peintres",
  "Carreleurs",
  "Paysagistes",
  "Serruriers",
  "Piscinistes",
  "Façadiers",
  "Garagistes",
  "Contrôleurs techniques",
  "Coiffeurs",
  "Instituts de beauté",
  "Fleuristes",
  "Restaurants",
  "Boulangeries",
  "Pâtisseries",
  "Traiteurs",
  "Photographes",
  "Agences immobilières",
  "Courtiers en assurance",
  "Courtiers en crédit",
  "Experts-comptables",
  "Ostéopathes",
  "Kinésithérapeutes",
  "Dentistes",
  "Vétérinaires",
  "Pompes funèbres",
];

export default function MetiersTicker() {
  const doubled = [...METIERS, ...METIERS];

  return (
    <div className="ticker-wrap" role="marquee" aria-label="Métiers et secteurs d'activité">
      <div className="ticker-track">
        {doubled.map((metier, i) => (
          <span className="ticker-item" key={i}>
            <span className="ticker-dot" aria-hidden="true" />
            {metier}
          </span>
        ))}
      </div>
    </div>
  );
}
